import { createGlobalStyle } from 'styled-components'
import 'reset-css'

import { mobile } from '@/components/utils/media-query'

import { giphyLightBlue } from './colors'
import './fonts.css'

export const GlobalStyle = createGlobalStyle`
  html {
  }

  body {
    margin: 0;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font: 1.125em/1.5 'Interface', 'Helvetica Neue', helvetica, sans-serif;
  }

  pre {
    display: block;
    font-family: monospace;
    white-space: pre;
    margin: 1.3em 0;
  }

  code {
    background-color: #EEF2F4;
    font-family: monospace;
    font-size: 14px;
  }

  ul {
    display: block;
    list-style-type: disc;
    margin-bottom: 1em;
    margin-left: 0;
    margin-right: 0;
    padding-left: 40px;
  }

  li {
    display: list-item;
  }

  blockquote {
    display: block;
    margin-bottom: 1em;
    margin-left: 40px;
    margin-right: 40px;
  }

  p {
    display: block;
    margin-bottom: 1em;
    margin-left: 0;
    margin-right: 0;
  }

  h1 {
    font-size: 48px;
    font-family: 'Nexa Black';
    line-height: 54px;
    margin: 0 0 15px 0;

    ${mobile.css`
            font-size: 32px;
        `}
  }

  h2 {
    font-family: 'Nexa Black';
    font-size: 34px;
    margin: 0 0 30px 0;
  }

  h3 {
    font-family: 'Interface';
    font-size: 26px;
    font-weight: bold;
    margin: 0 0 18px 0;
  }

  h4 {
    font-family: 'Interface';
    font-size: 20px;
    font-weight: regular;
    opacity: 0.85;
    letter-spacing: 0.4px;
    line-height: 30px;
    margin: 0 0 20px 0;
  }

  h5 {
    font-family: 'Interface';
    font-size: 20px;
    font-weight: bold;
    margin: 0 0 20px 0;
  }

  h6 {
    font-family: 'Interface';
    font-size: 18px;
    font-weight: bold;
    margin: 0 0 10px 0;
  }

  p {
    font-family: 'Interface';
    font-size: 18px;
    line-height: 24px;
    margin: 0 0 24px 0;
  }

  a {
    color: ${giphyLightBlue};
    text-decoration: none;
    border-bottom: 1px ${giphyLightBlue} solid;
    padding-bottom: 0px;
  }

  i {
    font-style: italic;
  }

  table {
    width: 100%;
    margin-bottom: 40px;
    border-spacing: 0 10px;
    border-collapse: separate;
  }

  th {
    font-weight: bold;
    font-size: 18px;
    white-space: nowrap;
  }


  td {
    padding: 16px 20px;
    vertical-align: middle;
    background: #F5F5F5;
    font-family: InterFace;
    font-size: 18px;
  }

  td strong, p strong {
    font-weight: bold;
  }

  strong {
    font-weight: bold;
  }

  td, th {
    text-align: left;
    word-wrap: break-word;
    word-break: break-word;
  }
`
